/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from "react";
import AssignedItemsTable from "./SubComponents/AssignedItemsTable";
/**
 * Component to render and manage assigned items with search, selection,
 * deletion, and dynamic endpoint integration.
 *
 * @param {Object} props - Component properties
 * @param {Function} props.setBodyForExport - Sets the request body used for export functionality
 * @param {Object} props.results - Data source containing assigned items and pagination info
 * @param {Function} props.setResults - Updates the results state
 * @param {string} props.searchElement - Current search input value
 * @param {Function} props.setSearchElement - Updates the search input value
 * @param {Function} props.setSearch - Triggers advanced search behavior
 * @param {Function} props.setSimpleSearch - Triggers simple search behavior
 * @param {boolean} props.modified - Indicates if the data has been modified
 * @param {Function} props.setModified - Updates the modified state
 * @param {Function} props.onDelete - Handles deletion of one or multiple items
 * @param {Array} props.selected - List of currently selected items
 * @param {Function} props.setSelected - Updates selected items
 * @param {string} props.labelRowsPerPage - Label for rows per page in pagination
 * @param {string} props.tableNotInformationLegend - Message displayed when no data is available
 * @param {Function} props.tableBuildBody - Function to build the request body for table queries
 * @param {Function} props.tableEndPoint - Endpoint function to fetch table data
 * @param {string} props.keyId - Unique identifier key for each item
 * @param {string} props.viewTypeName - View type identifier for rendering variations
 * @param {boolean} props.isAllChecked - Indicates if all items are selected
 * @param {Function} props.setIsAllChecked - Updates the "select all" state
 * @param {Function} props.checkbox - Show/ hide checkbox
 * @param {Function} props.renderAssignedItem - Function used to render each assigned item r
 * @param {JSX.Element} [props.renderModuleTitle] - Optional module title node; when set it is rendered inline before the search on the same row
 * @param {boolean} [props.autoHeight=true] - When false, disables the viewport-height auto-sizing on the table; use in embedded/expand contexts to avoid overflow
 * @param {number} [props.bottom=60] - Bottom offset used to compute the "no data" container height
 * @returns {JSX.Element} Assigned items table component
 */
const CustomAssignedItems = (props) => {
    const {
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
        onDelete,
        selected,
        setSelected,
        labelRowsPerPage,
        tableNotInformationLegend,
        tableBuildBody,
        tableEndPoint,
        keyId,
        viewTypeName,
        isAllChecked,
        setIsAllChecked,
        checkbox,
        searchTitle,
        renderAssignedItem,
        renderModuleTitle,
        autoHeight=true,
        bottom=60,
        containerClass='row py-3'
    } = props;

    return (
        <div className={containerClass}>
            <AssignedItemsTable
                keyId={keyId}
                setBodyForExport={setBodyForExport}
                results={results}
                setResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                modified={modified}
                setModified={setModified}
                labelRowsPerPage={labelRowsPerPage}
                tableNotInformationLegend={tableNotInformationLegend}
                onDelete={onDelete}
                tableBuildBody={tableBuildBody}
                tableEndPoint={tableEndPoint}
                selected={selected}
                setSelected={setSelected}
                viewTypeName={viewTypeName}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                checkbox={checkbox}
                renderAssignedItem={renderAssignedItem}
                searchTitle={searchTitle}
                renderModuleTitle={renderModuleTitle}
                autoHeight={autoHeight}
                bottom={bottom}
            />
        </div>
    );

}

export default CustomAssignedItems
